module.exports = __webpack_public_path__ + "media/images/success_checkmark-37b2a375.svg";